.resetButton {
  padding-left: 0;
  padding-right: 0;
}
